import ajax from '@assets/js/interceptor';
import { getTempGroupList, disableStatus, enableStatus, createTempGroup, editTempGroup, getTempGroupDetail } from '@/api/tempGroupManage';
export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: [],
    filter: {},
    detail: {}
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    getTableInfo ({ commit, dispatch, state }, { filter }) {
      const pasFilter = { ...filter };
      getTempGroupList(pasFilter).then(res => {
        const { data, code } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { dataSource: data.records, totalCount: data.total, filter });
        }
      });
    },
    submitTempGroup ({ commit }, { formData, isEdit }) {
      return new Promise(resolve => {
        // 提交
        // 通过 idEdit 判断是否是编辑的地址啥的
        const method = isEdit ? editTempGroup : createTempGroup;
        method(formData).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(true);
          }
        });
      });
    },
    getDetail ({ commit, dispatch, state }, { id }) {
      getTempGroupDetail(id).then(res => {
        const { code, data } = res.data;
        if (code == 200) {
          commit('SAVE_STATE', { detail: data });
        }
      });
    },
    // 启用，停用
    submitStatus ({ commit, dispatch }, { id, status }) {
      return new Promise(resolve => {
        //
        const method = status == 1 ? disableStatus : enableStatus;
        method(id).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(true);
          }
        });
      });
    }
  }
};
